var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4472 6.80008C33.589 6.80008 40.9998 14.2109 40.9998 23.3527C40.9998 32.4945 33.589 39.9053 24.4472 39.9053L19.0502 39.9053C19.5691 38.904 19.8894 37.7831 19.9591 36.5949L25.3576 36.5948C30.5227 36.5948 34.7098 32.4077 34.7098 27.2426C34.7098 22.0775 30.5227 17.8903 25.3576 17.8903H22.7919C16.8759 17.8903 11.9667 22.2009 11.0337 27.8527C9.90912 27.9418 8.8477 28.2558 7.89453 28.7498L7.89458 6.80008H24.4472Z",
    fill: "#003EBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6974 31.4053C14.2917 31.4053 16.3947 33.5084 16.3947 36.1027C16.3947 38.697 14.2917 40.8 11.6974 40.8C9.10308 40.8 7 38.697 7 36.1027C7 33.5084 9.10308 31.4053 11.6974 31.4053Z",
    fill: "#003EBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppicon);
export default __webpack_public_path__ + "static/media/appicon.6520bf9e20f81b68fa911e1c8094f01d.svg";
export { ForwardRef as ReactComponent };